import { createSelector } from 'reselect'
import { FINANCIAL_ADVISOR, SERVICES_MANAGER } from 'utils/Client/dedicatedTeam'

/* Utility functions */

const getTeamMembersState = state => state.teamMembers

const getTeamMembers = createSelector(
  getTeamMembersState,
  state => state.teamMembers,
)

const financialAdvisor = team => team.find(member => member.title === FINANCIAL_ADVISOR)
const clientServicesManager = team => team.find(member => member.title === SERVICES_MANAGER)

export const getFinancialAdvisor = team => financialAdvisor(team) || team[0]
export const getServicesManager = team => clientServicesManager(team) || team[0]

/* Selectors */

export const getFirstTeamMember = createSelector(
  getTeamMembers,
  teamMembers => getFinancialAdvisor(teamMembers)
)

export const getNextTeamMembers =  createSelector(
  getTeamMembers,
  (teamMembers) => {
    const remainingMembers = teamMembers.filter(mem => mem !== getFinancialAdvisor(teamMembers))
    const servicesManager = getServicesManager(remainingMembers)
    const nextMembers = [servicesManager, ...remainingMembers.filter(
      member => member !== servicesManager)
    ].filter(m => !!m)

    return nextMembers
  }
)

export default {
  getFirstTeamMember,
  getNextTeamMembers
}



// WEBPACK FOOTER //
// ./src/selectors/onlineExperience/teamMembers.js